import { render } from "./DVCommand.vue?vue&type=template&id=9a5b4470"
import script from "./DVCommand.vue?vue&type=script&lang=js"
export * from "./DVCommand.vue?vue&type=script&lang=js"

import "./DVCommand.vue?vue&type=style&index=0&id=9a5b4470&lang=css"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__